// Client-side file export — no server involved. Triggers a real browser download
// via a Blob + temporary <a>, used for both CSV exports and plain-text receipts.
//
// Values here can come from untrusted user input (e.g. a customer's booking
// name) — if a cell starts with =, +, -, @, tab, or CR, Excel/Sheets can
// interpret it as a formula on open ("CSV/formula injection"). Prefixing
// with a single quote neutralizes that while staying invisible in the
// rendered cell.
function csvEscape(value) {
  let str = String(value ?? "");
  if (/^[=+\-@\t\r]/.test(str)) str = `'${str}`;
  return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
}

function downloadBlob(filename, content, mimeType) {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function downloadCsv(filename, columns, rows) {
  const header = columns.map((c) => csvEscape(c.label)).join(",");
  const body = rows.map((row) => columns.map((c) => csvEscape(row[c.key])).join(",")).join("\n");
  downloadBlob(filename, `${header}\n${body}`, "text/csv;charset=utf-8;");
}

export function downloadText(filename, content) {
  downloadBlob(filename, content, "text/plain;charset=utf-8;");
}
